import script from "./ChatListBody.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatListBody.vue?vue&type=script&setup=true&lang=js"

import "./ChatListBody.vue?vue&type=style&index=0&id=1b4d8a76&lang=scss"

const __exports__ = script;

export default __exports__